import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
import { contact, images } from '../data/site';
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden bg-navy" data-id="element-55" data-mp="ei1v1l1sq0xf">
      <img src={images.hero} alt="Immaculately clean modern apartment living room overlooking a Guernsey harbour" className="absolute inset-0 h-full w-full object-cover" data-id="element-56" data-mp="9l34fchccc3z" />
      <div className="absolute inset-0 bg-navy/70" aria-hidden="true" data-id="element-57" data-mp="128phdbcgkt3i" />

      <div className="relative mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-6 py-24 lg:min-h-[680px]" data-id="element-58" data-mp="xbfht2vcv11y">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-2xl" data-id="element-59" data-mp="s9ggrzn38g86">
          <h1 className="font-display text-4xl font-black uppercase leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-60" data-mp="3d2tpxe128sgn">
            Professional Property Cleaning Services Across Guernsey
          </h1>
          <p className="mt-6 max-w-lg text-lg text-white/85" data-id="element-61" data-mp="3j6oe7qokeyt9">
            Trusted by Estate Agencies, Landlords, Developers, Airbnb Hosts &amp;
            Businesses.
          </p>
          <p className="mt-3 font-display text-lg font-bold text-gold-light" data-id="element-62" data-mp="39a32kmi1ipgg">
            Clean Spaces. Better Places.
          </p>

          <div className="mt-9 flex flex-col gap-4 sm:flex-row" data-id="element-63" data-mp="30iayctjm0ckb">
            <a href={contact.phoneHref} className="flex items-center justify-center gap-3 bg-gold px-8 py-4 text-center font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-gold-dark" data-id="element-64" data-mp="30fy8lu7m0xwp">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-65" data-mp="2vjq0h0rty4z1" />
              Call {contact.phone}
            </a>
            <a href="#services" className="border border-white/70 px-8 py-4 text-center font-display text-[13px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-navy" data-id="element-66" data-mp="2hjyot6osd0o7">
              Our Services
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}